<template>
  <b-card class="mb-2">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div>
        <h5 class="mb-0">
          Saldo actual
        </h5>
      </div>

      <div class="d-flex align-items-center">

        <b-spinner
          v-if="loading"
          small
          class="mr-1"
        />
        <h2 class="mb-0 text-success">
          {{ balance | money }}
        </h2>
      </div>
    </div>

    <!-- KPIs -->
    <div class="d-flex flex-wrap mb-2">
      <div class="mr-3">
        <div class="text-muted small">
          Abonos
        </div>
        <div class="font-weight-bold">
          {{ kpis.credits | money }}
        </div>
      </div>
      <div class="mr-3">
        <div class="text-muted small">
          Egresos
        </div>
        <div class="font-weight-bold text-danger">
          {{ kpis.debits | money }}
        </div>
      </div>
      <div class="mr-3">
        <div class="text-muted small">
          Ajustes netos
        </div>
        <div
          class="font-weight-bold"
          :class="adjustmentsClass"
        >
          {{ kpis.adjustments | money }}
        </div>
      </div>
      <div>
        <div class="text-muted small">
          Movimientos
        </div>
        <div class="font-weight-bold">
          {{ kpis.count || 0 }}
        </div>
      </div>

      <div class="ml-auto">
        <slot name="actions" />
      </div>
    </div>

    <!-- Filtros -->
    <b-form @submit.prevent="apply">
      <div class="d-flex flex-wrap align-items-end">
        <b-form-datepicker
          v-model="localFilters.from"
          size="sm"
          class="mr-1 mb-1"
          placeholder="Desde"
        />
        <b-form-datepicker
          v-model="localFilters.to"
          size="sm"
          class="mr-1 mb-1"
          placeholder="Hasta"
        />
        <b-form-select
          v-model="localFilters.type"
          size="sm"
          class="mr-1 mb-1"
          :options="typeOptions"
        />
        <b-form-input
          v-model="localFilters.q"
          size="sm"
          class="mr-1 mb-1"
          placeholder="Buscar nota/folio…"
        />
        <b-button
          size="sm"
          variant="primary"
          class="mb-1"
          type="submit"
        >
          Aplicar
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          class="mb-1 ml-1"
          @click="reset"
        >
          Limpiar
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>

export default {
  name: 'WalletSummaryCard',
  filters: {
    money(v) {
      const n = Number(v || 0)
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n)
    },
  },
  props: {
    balance: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    kpis: {
      type: Object,
      default: () => ({
        credits: 0, debits: 0, adjustments: 0, count: 0,
      }),
    },
    filters: {
      type: Object,
      default: () => ({
        from: null, to: null, type: null, q: '',
      }),
    },
  },
  data() {
    return {
      localFilters: { ...this.filters },
      typeOptions: [
        { value: null, text: 'Todos' },
        { value: 'credit', text: 'Abonos' },
        { value: 'debit', text: 'Egresos' },
        { value: 'adjustment', text: 'Ajustes' },
      ],
    }
  },
  computed: {
    adjustmentsClass() {
      const adjustments = Number((this.kpis && this.kpis.adjustments) || 0)
      if (adjustments > 0) return 'text-success'
      if (adjustments < 0) return 'text-danger'
      return 'text-warning'
    },
  },
  methods: {
    apply() {
      this.$emit('apply-filters', { ...this.localFilters })
    },
    reset() {
      this.localFilters = {
        from: null, to: null, type: null, q: '',
      }
      this.apply()
    },
  },
}
</script>
